import api from '../index';

const offPlatformReviewUpdaters = {
  createApproval: async ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    contentSubmissionId, // passed intentionally so we can use it in the onMutate callback for optimistic update
    contentSubmissionVersionId,
    step,
    email,
  }: {
    contentSubmissionId: string;
    contentSubmissionVersionId: string;
    step: string;
    email: string;
  }) => {
    return api.post(
      `/content_submission_versions/${contentSubmissionVersionId}/approvals`,
      {steps: [step], email},
      {
        customSerializer: (data: {data: object}) => ({
          data: {
            ...data.data,
            type: 'content-submission-approvals',
          },
        }),
      }
    );
  },
};

export default offPlatformReviewUpdaters;
